import { Outlet } from "react-router-dom";

export function BasicLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
